export default __webpack_public_path__ + "static/media/default_ticket_template.2450ae9a.xd";